import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from 'vue'
import { useEventListener } from '@vueuse/core'
import LoginForms from '@/components/auth/LoginSpecialForms.vue'
import IntroductionRequestForm from '@/components/format-edit/IntroductionRequestForm.vue'
import IntroductionRequestSampleDialog from '@/components/format-edit/IntroductionRequestSampleDialog.vue'
import { useAuth } from '@/composables/useAuth'
import { useIntroductionDialogStore } from '@/stores/introductionDialog'

type HostVm = {
  $varuna: { endPoints: Record<string, string> }
  $deviceLib: { isOnline: boolean; isMobileDevice: boolean }
  $message: (opts: Record<string, unknown>) => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IntroductionDialog',
  setup(__props) {

/**
 * 推薦・紹介文依頼 UI。開閉・状態は Pinia `useIntroductionDialogStore`。
 */
const vm = getCurrentInstance()!.proxy as unknown as HostVm
const { isAuthenticated } = useAuth()
const store = useIntroductionDialogStore()

function onSubmit() {
  store.submit({
    isOnline: vm.$deviceLib.isOnline,
    isMobileDevice: vm.$deviceLib.isMobileDevice,
    requestIntroductionUrl: vm.$varuna.endPoints.requestIntroduction,
    message: vm.$message
  })
}

useEventListener(window, 'popstate', () => store.close())

return { __sfc: true,vm, isAuthenticated, store, onSubmit, LoginForms, IntroductionRequestForm, IntroductionRequestSampleDialog }
}

})